<template>
	<div class="inputNumber">
		<div class="inputNumber-minus" @click="minus" @keydown.enter="minus" tabindex="0">&ndash;</div>
		<input class="inputNumber-input" type="text" :value="modelValue" @input="change($event.target.value)">
		<div class="inputNumber-plus" @click="plus" @keydown.enter="plus" tabindex="0">+</div>
	</div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import clamp from '../functions/clamp';

export default defineComponent({
	props: {
		modelValue: {
			type: Number,
			default: 0,
		},
		min: {
			type: Number,
			default: -Number.MAX_VALUE,
		},
		max: {
			type: Number,
			default: Number.MAX_VALUE,
		},
	},
	setup(props, { emit }) {
		const change = (value) => { emit('update:modelValue', clamp(value, props.min, props.max)) };
		const plus = () => { change(props.modelValue + 1) };
		const minus = () => { change(props.modelValue - 1) };

		return {
			change,
			plus,
			minus,
		};
	},
})
</script>
